export default __webpack_public_path__ + "static/media/applestore-badge.15f01eef.svg";